import type { MouseEvent } from 'react';
import type { Placement } from '@floating-ui/core';

export const getPlacement = (align: 'left' | 'right', isSubmenu: boolean = false): Placement => {
  if (isSubmenu) {
    switch (align) {
      case 'right':
        return 'right-start';
      case 'left':
        return 'left-start';
      default:
        return 'right-start';
    }
  }

  switch (align) {
    case 'right':
      return 'bottom-start';
    case 'left':
      return 'bottom-end';
    default:
      return 'bottom-start';
  }
};

export const stopPropagation = (e: MouseEvent) => {
  e.stopPropagation();
};
